import IconTile from '../../Icon/IconTile';

const SquareAdd = () => <IconTile name="addSquare" />;

export { SquareAdd };
